import React from 'react';
import './EventText.scss';
import { Icon } from 'antd';
import FormattedText from 'Components/Shared/FormattedText/FormattedText';

interface IProps {
  shortText: string;
  longText: string;
}

interface IState {
  isShowingFullText: boolean;
}

class EventText extends React.PureComponent<IProps, IState> {
  static defaultProps: Partial<IProps> = {
    shortText: '',
    longText: '',
  }

  constructor(props: IProps) {
    super(props);

    this.state = {
      isShowingFullText: false,
    }
  }

  toggleText = () => {
    const isShowingFullText = !this.state.isShowingFullText;
    this.setState({ isShowingFullText });
  }

  onPrint = () => {
    window.print();
  }

  render() {
    const { shortText, longText } = this.props;

    const printButton = (
      <div className='print' onClick={ this.onPrint }>
        <Icon type='printer' />
        <FormattedText
          displayName='Skriv ut denna sidan'
          formattedName='global.print'
        />
      </div>
    );

    if (!shortText.length && !longText.length) {
      return (
        <div className='event-text'>
          { printButton }
        </div>
      );
    }

    if (!shortText.length) {
      return (
      <div className='event-text'>
        <div className='text' dangerouslySetInnerHTML={ { __html: longText } } /> 
        <div className='footer'>{ printButton }</div>
      </div>
      );
    }

    if (!longText.length) {
      return (
        <div className='event-text'>
          <div className='text'>{ shortText }</div>
          <div className='footer'>{ printButton }</div>
        </div>
      );
    }

    const { isShowingFullText } = this.state;
    const toggleIcon = isShowingFullText ? 'minus-square-o' : 'plus-square-o';

    const toggleButton = (
      <div className='toggle' onClick={ this.toggleText }>
        <Icon type={ toggleIcon } />
        { isShowingFullText ? 
          <FormattedText 
            displayName='Visa kort text'
            formattedName='global.hidefulltext'
          /> :
          <FormattedText 
            displayName='Visa hela texten'
            formattedName='global.showfulltext'
          />
        }
      </div>
    );

    return (
      <div className='event-text'>
        { isShowingFullText ?
          <div className='text' dangerouslySetInnerHTML={ { __html: longText } } /> :
          <div className='text' dangerouslySetInnerHTML={ { __html: shortText } }/>
        }
        <div className='footer'>
          { toggleButton }
          { printButton }
        </div>
      </div>
    );
  }
};

export default EventText;


// WEBPACK FOOTER //
// ./src/pages/EventDetailPage/EventText/EventText.tsx